// src/Components/TeamImageModal/TeamImageModal.jsx
import '../TeamImageModal/TeamImageModal.css';


const TeamImageModal = ({ isOpen, onClose, imageUrl, teamName }) => {
  
  if (!isOpen) return null; // נפתח תמיד כשנדרש

  return (

    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>{teamName}</h3>
        {imageUrl ? (
        <img src={imageUrl} alt={teamName} />
        ) : (
          <p style={{ color: "red", fontWeight: "bold" }}>
            אין תמונה לקבוצה זו
          </p>
        )}
        <button className="close-btn" onClick={onClose}>סגור</button>
      </div>
    </div>
  );
};

export default TeamImageModal;
